import SendsHistoryControl from "../Controls/SendsHistoryControl";
import React, {useRef} from "react";
import {Modal, ModalSize, ModalType} from "@twigsby/frontend-framework";

interface PageHistoryModalType extends ModalType {
    pageId: number;
}

const PageHistoryModal = (props: PageHistoryModalType) => {
    const sendsHistoryRef = useRef<any>();

    return (
        <Modal title={'Page History'} isOpen={props.isOpen} closeCallback={() => props.closeCallback()} modalSize={ModalSize.Large}>
            <SendsHistoryControl containerRef={sendsHistoryRef} hideHeader={true} />
        </Modal>
    )
}

export default PageHistoryModal